import React, { useRef } from 'react';
import cn from 'classnames';

import arrived from 'assets/images/glossary/GlossaryArrived.svg';
import cancelled from 'assets/images/glossary/GlossaryCancelled.svg';
import confirmed from 'assets/images/glossary/GlossaryConfirmed.svg';
import deposited from 'assets/images/glossary/GlossaryDeposited.svg';
import dr from 'assets/images/glossary/GlossaryDepositRequested.svg';
import newclient from 'assets/images/glossary/GlossaryNewClient.svg';
import notes from 'assets/images/glossary/GlossaryNotes.svg';
import DropdownFoldout from 'components/generic/DropdownFoldout.component';
import useOnClickOutside from 'hooks/useOnClickOutsideRef.hook';
import useTip from 'hooks/useTip.hook';
import { useTheme } from 'providers/Theme.provider';

import FaqButton from 'scheduler/components/common/FaqButton.component';

import CN from './GlossaryIcons.module.scss';

const MENU_ITEMS = [
  {
    id: 1,
    title: 'Client has confirmed',
    imgSrc: confirmed,
  },
  {
    id: 2,
    title: 'Client has cancelled',
    imgSrc: cancelled,
  },
  {
    id: 3,
    title: 'Client has arrived',
    imgSrc: arrived,
  },
  {
    id: 4,
    title: 'Client has paid a deposit',
    imgSrc: deposited,
  },
  {
    id: 5,
    title: 'Deposit requested but not paid',
    imgSrc: dr,
  },
  {
    id: 6,
    title: 'Notes specific to this appointment',
    imgSrc: notes,
  },
  {
    id: 7,
    title: 'New client',
    imgSrc: newclient,
  },
];

const GlossaryIcons = () => {
  const { isDarkMode } = useTheme();

  const wrapperRef = useRef(null);

  const { val: isRendered, tip: toggle, nay: close } = useTip(false);

  useOnClickOutside(wrapperRef, close);

  return (
    <div
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
      data-bem="GlossaryIcons"
      ref={wrapperRef}
    >
      <FaqButton tag="GlossaryIcons" onClick={toggle} active={isRendered} />

      {isRendered && (
        <DropdownFoldout width="lg" position="glossaryButton">
          <DropdownFoldout.Header>
            <div className={CN.dropdownTitle}>What do the appointment icons mean?</div>
          </DropdownFoldout.Header>
          <DropdownFoldout.Body>
            <div className={CN.panel}>
              <ul className={CN.list}>
                {MENU_ITEMS.map((item) => (
                  <li key={item.id} className={CN.item}>
                    <img src={item.imgSrc} alt={item.title} className={CN.icon} />
                    <span className={CN.title}> {item.title}</span>
                  </li>
                ))}
              </ul>
            </div>
          </DropdownFoldout.Body>
        </DropdownFoldout>
      )}
    </div>
  );
};

export default GlossaryIcons;
